import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useSelector } from 'react-redux';
import { GridLeft } from './Pdf2284Styled';
import { useReactToPrint } from 'react-to-print';
import { GridSection } from '../../../Episode.Styled';
import {
  getReportingDetails,
  getResponseAgencies,
  getDivisions,
  getGridFirstRow,
  getGridSecondRow,
  getGridThirdRow,
  getGridFourthRow,
  getFifthRowCheckbox,
  getGridSixthRow,
  getGridSeventhRow,
  getSeventhRowCheckbox,
  getGridEightthRow,
  getEightthRowCheckbox,
  getFirstRowCheckbox,
  descriptionTitle1,
  descriptionTitle2,
  distributionTitle1,
  distributionTitle2,
} from './Pdf2284Constants';
import {
  mappedData,
  mappedCheckBox,
  HeaderGrid,
  DiscriptionGrid,
  DistributionGrid,
  PrintButtonHeader,
  reportingDetailsGrid,
} from './Pdf2284CommonUtils';
import {
  getValidDate,
  getValidTime,
  getYesNo,
} from '../../../../common/commonUtils/commonUtils';

const Pdf2284 = (props) => {
  const { open, setOpen } = props;

  const getincidentReportPdfForm = useSelector(
    (state) => state?.incidentReportPdfForm
  );

  const {
    epdIRNewsMediaPhone = '',
    epdIRLocation = '',
    epdIRLocationAddr = '',
    epdIRNewMediaName = '',
    epdIRLawEnforcementContacted,
    epdIRArrested,
    epdIRNewsMedia,
    epdIRTime,
    epdIRDate,
    epdIRCMName = '',
    epdIRCMEmail = '',
    epdIRCMPhone = '',
    epdIRLawEnforcementAgency = '',
    prtKey = '',
    epdIRAdmitDate,
    epdIRAgenciesContacted = '',
    epdIRReportingPersonName = '',
    epdIRReportingPersonPhone = '',
    epdIRReportingPersonTitle = '',
    epdIRDescription = '',
    epdIcnCDC = '',
    epdIRArrestingAgency = '',
    epdIRArrestDate,
    epdIRNotifiedDAPO,
    epdIRNotifiedDHCS,
    epdIRNotifiedDRP,
    epdIRNotifiedOther,
  } = getincidentReportPdfForm || {};

  const handleClose = () => {
    setOpen(false);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const divisions = getDivisions({
    epdIRNotifiedDAPO,
    epdIRNotifiedDHCS,
    epdIRNotifiedDRP,
    epdIRNotifiedOther,
  });

  const yesNoOptions = getYesNo(epdIRLawEnforcementContacted);
  const getPerrolArrested = getYesNo(epdIRArrested);
  const getMediaCoverage = getYesNo(epdIRNewsMedia);
  const getIncidentDate = getValidDate(epdIRDate);
  const getIncidentTime = getValidTime(epdIRTime);
  const getAdmissionDate = getValidDate(epdIRAdmitDate);
  const getArrestDate = getValidDate(epdIRArrestDate);

  const reportingDetails = getReportingDetails({
    epdIRReportingPersonName,
    epdIRReportingPersonPhone,
    epdIRReportingPersonTitle,
  });

  const gridFirstRow = getGridFirstRow({ getIncidentDate, getIncidentTime });

  const firstRowCheckBox = getFirstRowCheckbox({ divisions });

  const gridSecondRow = getGridSecondRow({ epdIcnCDC, prtKey });

  const gridThirdRow = getGridThirdRow({ epdIRLocation, epdIRLocationAddr });

  const gridFourthRow = getGridFourthRow({
    getAdmissionDate,
    epdIRCMName,
    epdIRCMPhone,
    epdIRCMEmail,
  });

  const fifthRowCheckBox = getFifthRowCheckbox({
    yesNoOptions,
    getPerrolArrested,
  });

  const gridSixthRow = getGridSixthRow({
    epdIRLawEnforcementAgency,
    epdIRArrestingAgency,
    getArrestDate,
  });

  const gridSeventhRow = getGridSeventhRow({ epdIRAgenciesContacted });

  const seventhRowCheckBox = getSeventhRowCheckbox({
    getMediaCoverage,
  });

  const gridEightthRow = getGridEightthRow({
    epdIRNewMediaName,
    epdIRNewsMediaPhone,
  });

  const eighthRowCheckBox = getEightthRowCheckbox({ getResponseAgencies });

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      <PrintButtonHeader handlePrint={handlePrint} handleClose={handleClose} />

      <Grid container ref={componentRef}>
        <GridSection mt={1} mx={2} container spacing={1}>
          <HeaderGrid
            leftTitle1="STATE OF CALIFORNIA"
            leftTitle2="INCIDENT REPORT (DRP)"
            leftTitle3="CDCR 2284 (04/14)"
            rightTitle1="CALIFORNIA DEPARTMENT OF CORRECTIONS AND REHABILITATION"
            rightTitle2="DIVISION OF REHABILITATION PROGRAMS"
            rightTitle3="OFFICE OF OFFENDER SERVICES/COMMUNITY AND RE-ENTRY SERVICES"
          />
        </GridSection>

        <GridSection mx={2} container spacing={1}>
          <GridLeft item container xs={12} justifyContent="space-between">
            {mappedCheckBox(firstRowCheckBox)}
            {mappedData(gridFirstRow)}
            {mappedData(gridSecondRow)}
            {mappedData(gridThirdRow)}
            {mappedData(gridFourthRow)}
            {mappedCheckBox(fifthRowCheckBox)}
            {mappedData(gridSixthRow)}
            {mappedCheckBox(eighthRowCheckBox)}
            {mappedData(gridSeventhRow)}
            {mappedCheckBox(seventhRowCheckBox)}
            {mappedData(gridEightthRow)}
          </GridLeft>
        </GridSection>

        <DiscriptionGrid
          title1={descriptionTitle1}
          title2={descriptionTitle2}
          description={epdIRDescription}
        />

        <GridSection mx={2} container spacing={1}>
          {reportingDetailsGrid(reportingDetails)}
        </GridSection>

        <GridSection mx={2} container spacing={1}>
          <DistributionGrid
            title1={distributionTitle1}
            title2={distributionTitle2}
          />
        </GridSection>
      </Grid>
    </Dialog>
  );
};

export default Pdf2284;

Pdf2284.defaultProps = {
  open: false,
  setOpen: () => {},
};
Pdf2284.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
